import React from "react";
const Input = function Input(props) {
    return (
        <div>
            <div className="field">
                <label className="label">{props.label}</label>
                <div className="control">
                    <input
                        value={props.inputvalue}
                        className="input is-medium"
                        type="text"
                        placeholder={ props.placeholder !=="" ? props.placeholder : null }
                        name={props.id}
                        onChange={props.onChangeFunc}
                        aria-describedby={ (props.placeholder!=="" ?  props.id + "Desc" : null) }
                    />
                </div>
                {props.placeholder!=="" ?
                    <span className="is-sr-only" id={props.id + "Desc"}>{props.placeholder}</span>
                    : ''
                }
            </div>
        </div>
    );
};

export default Input;
